const styles = {
  alert: (theme) => ({
    borderRadius: "unset"
  }),
}

export default styles;